import { isEmpty, replace } from "lodash";

export const formatPhone = (phone: string, usCountyCode?: string): string => {
  if (isEmpty(phone)) {
    return "";
  }

  let formattedPhone = phone.replace(/\D+/g, "");

  if (formattedPhone.length !== 10) {
    return phone;
  }

  formattedPhone = formattedPhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  if (usCountyCode) {
    formattedPhone = `${usCountyCode} ${formattedPhone}`;
  }

  return formattedPhone;
};

export const getPhoneWithoutCode = (phone: string) => {
  if (isEmpty(phone)) {
    return "";
  }

  return replace(phone, /\D+/g, "").slice(-10);
};

/**
 * @deprecated - use lodash util
 * Returns a string with first letter capital
 * @param {as type string} string
 */
const capitalizeFirstLetter = (string?: string) => {
  if (!string || typeof string !== "string") {
    return string;
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Returns a human readable string for a tag/method string
 * @param {tag like 'RUSH_FEE' as string} tag
 */
export const getHumanReadableTag = (tag?: string) => {
  if (!tag || typeof tag !== "string") {
    return tag;
  }

  return tag
    .split("_")
    .map((splittedTag) => {
      return capitalizeFirstLetter(splittedTag.toLowerCase());
    })
    .join(" ");
};
